import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '@/components/feature/Layout';

const testimonialIds = [1, 2, 3];

const testimonialMeta: Record<number, { avatar: string; stars: number }> = {
  1: { avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20European%20man%20in%20his%20mid%2020s%20with%20short%20light%20brown%20hair%20wearing%20a%20crisp%20light%20blue%20shirt%20against%20a%20clean%20neutral%20background%20friendly%20and%20slightly%20nervous%20but%20genuine%20expression%20natural%20lighting%20professional%20portrait%20photography%20realistic%20corporate%20style&width=120&height=120&seq=avatar-lukas-ger-01&orientation=squarish', stars: 5 },
  2: { avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20confident%20European%20woman%20in%20her%20early%2030s%20with%20shoulder%20length%20blonde%20hair%20wearing%20a%20navy%20blazer%20over%20a%20white%20blouse%20against%20a%20clean%20light%20background%20warm%20but%20determined%20expression%20natural%20lighting%20professional%20portrait%20photography%20realistic%20corporate%20headshot&width=120&height=120&seq=avatar-amelie-bel-02&orientation=squarish', stars: 5 },
  3: { avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20European%20man%20in%20his%20early%2030s%20with%20dark%20brown%20hair%20and%20a%20short%20beard%20wearing%20a%20light%20grey%20blazer%20against%20a%20warm%20clean%20background%20relaxed%20confident%20smile%20natural%20lighting%20professional%20portrait%20photography%20mediterranean%20vibe%20realistic%20corporate%20style&width=120&height=120&seq=avatar-carlos-spa-03&orientation=squarish', stars: 5 },
};

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <Layout>
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 bg-primary-800 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-accent-500 blur-3xl" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-400 blur-3xl" />
        </div>
        <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16 text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-300 mb-4">
            {t('testimonials.label')}
          </p>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {t('testimonialsPage.heroTitle')}
          </h1>
          <p className="text-base text-foreground-200 max-w-[600px] mx-auto leading-relaxed">
            {t('testimonialsPage.heroSubtitle')}
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16 px-6 md:px-10 lg:px-16 bg-background-50">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl p-7 border border-background-200/70 text-center">
              <div className="font-heading text-5xl font-bold text-accent-500 mb-2">{t('about.stats1.number')}{t('about.stats1.suffix')}</div>
              <p className="text-xs text-foreground-500 uppercase tracking-wider font-semibold">{t('testimonialsPage.statMentored')}</p>
            </div>
            <div className="bg-white rounded-2xl p-7 border border-background-200/70 text-center">
              <div className="font-heading text-5xl font-bold text-accent-500 mb-2">{t('about.stats2.number')}{t('about.stats2.suffix')}</div>
              <p className="text-xs text-foreground-500 uppercase tracking-wider font-semibold">{t('testimonialsPage.statSuccess')}</p>
            </div>
            <div className="bg-white rounded-2xl p-7 border border-background-200/70 text-center">
              <div className="font-heading text-5xl font-bold text-accent-500 mb-2">6<span className="text-2xl">m</span></div>
              <p className="text-xs text-foreground-500 uppercase tracking-wider font-semibold">{t('testimonialsPage.statMonths')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-accent-50">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonialIds.map((id) => {
              const meta = testimonialMeta[id];
              return (
                <div
                  key={id}
                  className="bg-white rounded-2xl p-6 border border-background-200/70 hover:border-accent-200 transition-all duration-200"
                >
                  <div className="flex items-center gap-0.5 mb-4">
                    {Array.from({ length: meta.stars }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm" />
                    ))}
                  </div>
                  <h4 className="font-heading text-base font-bold text-foreground-950 mb-2 leading-snug">
                    {t(`testimonials.items.${id}.headline`)}
                  </h4>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                    {t(`testimonials.items.${id}.text`)}
                  </p>
                  <div className="flex items-center gap-3 pt-4 border-t border-background-100">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={meta.avatar}
                        alt={t(`testimonials.items.${id}.name`)}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t(`testimonials.items.${id}.name`)}</p>
                      <p className="text-xs text-foreground-400">{t(`testimonials.items.${id}.role`)}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-primary-500">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
            {t('testimonialsPage.cta')}
          </h2>
          <Link
            to="/booking"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-primary-700 font-semibold text-sm rounded-full hover:bg-accent-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta1')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>
    </Layout>
  );
}